export const wishlistFilters = [
  { label: "All", value: "all" },
  { label: "In Stock", value: "in-stock" },
  { label: "Sale", value: "sale" },
  { label: "Best Seller", value: "best-seller" },
  { label: "New", value: "new" },
];

export const wishlistSortOptions = [
  { label: "Newest", value: "newest" },
  { label: "Price: Low to High", value: "price-low" },
  { label: "Price: High to Low", value: "price-high" },
  { label: "Highest Rated", value: "rating" },
  { label: "Alphabetical", value: "alphabetical" },
];
